import { render, staticRenderFns } from "./DefaultMenu.vue?vue&type=template&id=2e385e3a&"
import script from "./DefaultMenu.vue?vue&type=script&lang=ts&"
export * from "./DefaultMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports